import { CriteoIntegration } from "./_criteoApi";

export class CriteoHomePage extends CriteoIntegration {
  #selectors = {
    container: "#criteo-owl-carousel",
    carousel: "#criteo-owl",
  };

  async exec() {
    if (!this._isActive) return;
    if (this._isMarketingBlocked()) return;

    const { placements } = await this._baseRequest("viewHome");

    if (!placements.length) {
      document.querySelector(this.#selectors.container).style.display = "none";
      return;
    }

    const device = screen.width <= 750 ? "Mobile" : "Desktop";

    const [
      {
        [`viewHomeApi${device}-MidCarousel`]: [
          { products, OnViewBeacon, OnLoadBeacon },
        ],
      },
    ] = placements;

    return await this._renderCarousel(products, OnViewBeacon, OnLoadBeacon);
  }
}
